import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { TabPanel } from '@mui/lab';
import { GraphCacheBuilder } from '../../../../hooks/filter';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
export const TableQueryFilter = ({ value }) => {
    const contextObject = getZombieInstanceFromPrimaryKey('Customer:269e4095-da85-4c21-a06e-beaa4a921c54');
    const knownPath = [
        {
            adjacentType: AdjacentType.CHILD,
            edgeTypeId: undefined,
            targetObjectTypeId: 'Group',
            filterGroups: [
                {
                    filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Customer' }],
                    setOperation: LogicalOperatorType.AND,
                },
            ],
        },
        {
            adjacentType: AdjacentType.CHILD,
            edgeTypeId: undefined,
            targetObjectTypeId: 'Customer',
        },
        {
            adjacentType: AdjacentType.CHILD,
            edgeTypeId: undefined,
            targetObjectTypeId: 'Group',
            filterGroups: [
                {
                    filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Customer' }],
                    setOperation: LogicalOperatorType.AND,
                },
            ],
        },
        {
            adjacentType: AdjacentType.CHILD,
            edgeTypeId: undefined,
            targetObjectTypeId: 'Device',
        },
    ];
    return (_jsx(TabPanel, { value, children: _jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: "2. Table Query Filter" }), _jsx(Typography, { children: "This is a context filter" }), _jsx(GraphCacheBuilder, { contextObject, knownPath }, 'a')] }) }, 'tableQueryFilter'));
};
